import { render, staticRenderFns } from "./dialogForm.vue?vue&type=template&id=03011a92&scoped=true"
import script from "./dialogForm.vue?vue&type=script&lang=js"
export * from "./dialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03011a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03011a92')) {
      api.createRecord('03011a92', component.options)
    } else {
      api.reload('03011a92', component.options)
    }
    module.hot.accept("./dialogForm.vue?vue&type=template&id=03011a92&scoped=true", function () {
      api.rerender('03011a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/order/source-strategy/parcel/components/dialogForm.vue"
export default component.exports